import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Banco de +100 Actividades Listas',
    desc: 'Ejercicios clasificados por nivel: lógica, pseudocódigo, Python y web. Listos para copiar, entregar e imprimir. Actividades para todo el año sin improvisar.',
    value: '$12.000'
  }, {
    num: '2',
    title: 'Evaluaciones y Rúbricas Pro',
    desc: 'Evaluaciones listas con criterios de corrección claros y rúbricas por competencias. Corrección rápida, justa y documentada.',
    value: '$8.500'
  }, {
    num: '3',
    title: 'Proyectos Extra para el Aula',
    desc: 'Proyectos adicionales para alumnos avanzados, ideas para ferias técnicas y actividades de trabajo en grupo con guía docente.',
    value: '$9.500'
  }, {
    num: '4',
    title: 'Planificación Anual Lista (NAP 2026)',
    desc: 'Plan anual completo alineado a los NAP vigentes con objetivos por trimestre y secuencia de contenidos lista para presentar.',
    value: '$6.000'
  }];
  return <section className="py-6 md:py-12 px-3 bg-brand-dark border-y border-brand-accent/20" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <div className="text-center mb-5" data-id="element-20">
          <h2 className="text-xl md:text-3xl font-black text-white" data-id="element-21">
            🎁 4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm md:text-base text-brand-accent font-bold mt-1 neon-glow" data-id="element-22">
            Todo lo que completa tu arsenal docente. Gratis con tu Kit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-5" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-lg p-3.5 border border-white/10 hover:border-brand-accent transition-colors relative overflow-hidden group" data-id="element-24">
              <div className="absolute -right-4 -top-4 w-16 h-16 bg-brand-accent/10 rounded-full group-hover:scale-150 transition-transform duration-500" data-id="element-25"></div>

              <div className="flex items-start mb-2 relative z-10" data-id="element-26">
                <div className="bg-brand-accent text-white font-black text-base w-8 h-8 rounded-md flex items-center justify-center mr-2.5 shrink-0" data-id="element-27">
                  {bonus.num}
                </div>
                <div data-id="element-28">
                  <div className="flex items-center gap-1 mb-0.5" data-id="element-29">
                    <Gift className="w-3 h-3 text-brand-accent" data-id="element-30" />
                    <span className="text-brand-accent font-black text-[10px] tracking-widest uppercase" data-id="element-31">
                      BONO {bonus.num}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-black leading-tight text-white" data-id="element-32">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-xs text-gray-300 relative z-10 mb-2 leading-relaxed" data-id="element-33">
                {bonus.desc}
              </p>

              <div className="bg-brand-dark p-2 rounded-md border border-white/5 relative z-10 text-center" data-id="element-34">
                <p className="text-[10px] text-gray-400" data-id="element-35">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-36">{bonus.value} ARS</span> —{' '}
                  <span className="text-brand-accent font-black text-xs" data-id="element-37">
                    HOY GRATIS
                  </span>
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-lg p-3 text-center border-2 border-brand-accent max-w-lg mx-auto shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-38">
          <p className="text-base md:text-lg font-bold text-gray-300" data-id="element-39">
            💰 Valor total bonos:{' '}
            <span className="line-through text-gray-500" data-id="element-40">$36.000 ARS</span>
            <br data-id="element-41" />
            <span className="text-brand-accent font-black neon-glow text-xl md:text-2xl block mt-1" data-id="element-42">
              👉 HOY GRATIS con tu Kit
            </span>
          </p>
        </div>
      </div>
    </section>;
}